"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pettinengo": {
    "a1ac8046": [{
      "hkey": "4cc33cba",
      "slug": "pettinengo",
      "name": "Pettinengo",
      "primary": true,
      "skipSearch": false
    }],
    "bauzarone": [{
      "hkey": "4cc33cba",
      "slug": "pettinengo",
      "name": "Pettinengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f27a57d": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "skipSearch": false
    }],
    "burzani": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }],
    "7e6ec8c7": [{
      "hkey": "4cc33cba",
      "slug": "pettinengo",
      "name": "Pettinengo",
      "primary": true,
      "skipSearch": false
    }],
    "case-sparse": [{
      "hkey": "4cc33cba",
      "slug": "pettinengo",
      "name": "Pettinengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "76307d88": [{
      "hkey": "6ce708eb",
      "slug": "livera-gurgo",
      "name": "Livera Gurgo",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "6ce708eb",
      "slug": "livera-gurgo",
      "name": "Livera Gurgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }],
    "cbdbd3c5": [{
      "hkey": "6ce708eb",
      "slug": "livera-gurgo",
      "name": "Livera Gurgo",
      "primary": true,
      "skipSearch": false
    }],
    "perino": [{
      "hkey": "6ce708eb",
      "slug": "livera-gurgo",
      "name": "Livera Gurgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }],
    "7e4cd82f": [{
      "hkey": "6ce708eb",
      "slug": "livera-gurgo",
      "name": "Livera Gurgo",
      "primary": true,
      "skipSearch": false
    }],
    "piana": [{
      "hkey": "6ce708eb",
      "slug": "livera-gurgo",
      "name": "Livera Gurgo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }],
    "01be6ee4": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "skipSearch": false
    }],
    "rosa": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }],
    "5bd0ad80": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "skipSearch": false
    }],
    "rossi": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }],
    "ade62ef3": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "skipSearch": false
    }],
    "selve-marcone": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e913c2dc": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "skipSearch": false
    }],
    "tappi": [{
      "hkey": "7d2ee1df",
      "slug": "tappi-rosa-rossi-burzano",
      "name": "Tappi, Rosa. Rossi. Burzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pettinengo"
    }]
  }
};
exports["default"] = _default;